import { makeApiRequest } from './utils/api';
import { GOHIGHLEVEL_CONFIG } from '../../config/gohighlevel.config';

/**
 * Crea un nuevo contacto en GoHighLevel
 * @param {object} userData - Datos del usuario
 * @param {object} values - Valores del formulario
 * @returns {Promise<object>} Contacto creado
 */
export const createGoHighLevelContact = async (userData, values) => {

  const contactData = {
    email: userData.email,
    firstName: userData.firstName,
    lastName: userData.lastName,
    phone: userData.phoneNumber,
    phoneLabel: "Mobile",
    locationId: GOHIGHLEVEL_CONFIG.LOCATION_ID,
    type: "lead",
  };

  try {
    const response = await makeApiRequest('/contacts/', 'POST', contactData);

    if (response?.contact?.id) {

      const tags = determineTags(userData, values);

      if (tags.length > 0) {
        const tagResponse = await addTagsToContact(response.contact.id, tags);
      }

      const updateResponse = await updateContact(response.contact.id, {
        email: userData.email,
        phone: userData.phoneNumber
      });
    } else {
      console.warn('⚠️ [createGoHighLevelContact] No se recibió ID en la respuesta');
    }

    return response;
  } catch (error) {
    console.error('❌ [createGoHighLevelContact] Error en la creación:', error);
    throw error;
  }
};

/**
 * Determina los tags basados en los datos del usuario
 * @param {object} userData - Datos del usuario
 * @param {object} values - Valores del formulario
 * @returns {string[]} Array de tags
 */
const determineTags = (userData, values) => {

  const tags = [];

  if (userData.broker) {
    tags.push('broker');
  }

  const propertyCondition = values["What condition is the property in?"];
  const loanLength = values["What is your ideal loan length?"];


  if (propertyCondition === "It needs some repairs and/or construction") {
    tags.push('fix and flip');
  }

  if (loanLength === "Long-term (30 years)") {
    tags.push('long term nurture');
  }

  return tags;
};

/**
 * Añade tags a un contacto
 * @param {string} contactId - ID del contacto
 * @param {string|string[]} tags - Tags a añadir
 * @returns {Promise<object>} Respuesta de la API
 */
export const addTagsToContact = async (contactId, tags) => {

  const tagData = {
    tags: Array.isArray(tags) ? tags : [tags]
  };

  try {
    const response = await makeApiRequest(`/contacts/${contactId}/tags`, 'POST', tagData);
    return response;
  } catch (error) {
    console.error('❌ [addTagsToContact] Error al añadir tags:', error);
    throw error;
  }
};

/**
 * Actualiza la información de un contacto
 * @param {string} contactId - ID del contacto
 * @param {object} contactData - Datos a actualizar
 * @returns {Promise<object>} Respuesta de la API
 */
export const updateContact = async (contactId, contactData) => {

  const updateData = {
    email: contactData.email,
    phone: contactData.phone,
    companyName: null,
    assignedTo: GOHIGHLEVEL_CONFIG.ASSIGNED_TO
  };

  try {
    const response = await makeApiRequest(`/contacts/${contactId}`, 'PUT', updateData);
    return response;
  } catch (error) {
    console.error('❌ [updateContact] Error al actualizar contacto:', error);
    throw error;
  }
}; 